import { Button, Form, Input, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useClientLoginMutation } from "../../../store/service/clientBetService";
import { APP_BRAND_MARK, APP_BRAND_TAIL } from "../../../utils/brand";
import "./Client.scss";

const ClientLogin = () => {
  const nav = useNavigate();
  const [login, { isLoading }] = useClientLoginMutation();

  const onFinish = async (values) => {
    try {
      const res = await login({
        userId: values.userId.trim(),
        password: values.password.trim(),
      }).unwrap();

      if (res?.token) {
        localStorage.setItem("client-token", res.token);
        localStorage.setItem("client-userId", res.userId);
        localStorage.setItem("client-username", res.username);
        message.success("Welcome back");
        nav("/play");
      }
    } catch (err) {
      message.error(err?.data?.message || "Invalid User ID or password");
    }
  };

  return (
    <div className="client-login-wrap">
      <div className="client-login-card">
        <h2 className="lotus-login-logo">
          <span className="lotus-logo-bet">{APP_BRAND_MARK}</span>
          <span className="lotus-logo-in">{APP_BRAND_TAIL}</span>
        </h2>
        <p className="client-login-sub">Player login</p>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item label="User ID" name="userId" rules={[{ required: true, message: "Enter your User ID" }]}>
            <Input size="large" placeholder="Your User ID" autoComplete="username" />
          </Form.Item>
          <Form.Item label="Password" name="password" rules={[{ required: true, message: "Enter your password" }]}>
            <Input.Password size="large" placeholder="Password" autoComplete="current-password" />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
            loading={isLoading}
            className="client-login-submit">
            Sign in
          </Button>
        </Form>
        <div className="client-hint">
          Use the User ID and password shared by your agent.
          <br />
          Need help? Contact support from the app menu after login.
        </div>
      </div>
    </div>
  );
};

export default ClientLogin;
